import * as CONST from '../ActionTypes';

const initialState = {
  transactionList: [],
  allTransactionList: [],
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function transaction(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済履歴一覧取得
    // -----------------
    case CONST.GET_TRANSACTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transactionList: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transactionList: [],
        },
      );
    // -----------------
    // 決済履歴全件取得
    // -----------------
    case CONST.GET_ALL_TRANSACTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          allTransactionList: action.payload,
        },
      );
    case CONST.GET_ALL_TRANSACTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          allTransactionList: [],
        },
      );
    // -----------------
    // 決済取り消し
    // -----------------
    case CONST.REFUND_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.REFUND_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_REFUND_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default transaction;
